// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorMessage_wrapper__yQfr9"};